import {typeExport} from "../../../../redux/store/type";

const reducerSubmitRequestOperationFireScreen = (state = {
    isLoading: false,
    NoInternetDialog: false,
    results: null,

    isLoadingSet: false,
    NoInternetDialogSet: false,
    resultsSet: null,

    position: 0, id_category: 1,
    positionPersonnel: 0, id_Personnel: 1,
}, action) => {
    switch (action.type) {
        case typeExport.SubmitRequestOperationFireScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: action.NoInternetDialog,
                showDialohCity: action.showDialohCity,
                isLoading: action.isLoading,
            };
        case typeExport.SubmitRequestOperationFireScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: action.NoInternetDialog,
                error: action.error,
                results: null,

                isLoading: action.isLoading,
            };

        case typeExport.SubmitRequestOperationFireScreen_SERVICE_SUCCESS:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: action.NoInternetDialog,
                isLoading: action.isLoading,

            };
        case typeExport.SubmitRequestOperationFireScreen_SERVICE_PENDING_Set:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
            };
        case typeExport.SubmitRequestOperationFireScreen_SERVICE_ERROR_Set:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                error: action.error,
                resultsSet: null,

                isLoadingSet: action.isLoadingSet,
            };

        case typeExport.SubmitRequestOperationFireScreen_SERVICE_SUCCESS_Set:
            return {
                ...state,
                resultsSet: action.resultsSet,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,

            };

        case typeExport.SubmitRequestOperationFireScreen_SERVICE_REFRESH:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: action.NoInternetDialog,
                isLoading: action.isLoading,

                resultsSet: action.resultsSet,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,

            };

        default:
            return state;
    }
}

export default reducerSubmitRequestOperationFireScreen;
